// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"ff41a498","581":"ff13e051","829":"f68110eb","913":"5f5fe264"}[chunkId] + ".chunk.js";
};